import React from "react";
import { format } from "date-fns";
import { Label } from "../../../components/shared/InputField";
import { Select } from "../../../components/shared/Select";
import {
  DATE_FORMAT_OPTIONS,
  DEFAULT_DATE_FORMAT_KEY,
  DateFormatKey,
} from "../../../utils/dateFormatCatalog";

type Props = {
  value?: DateFormatKey;
  onChange: (value: DateFormatKey) => void;
};

const DateFormatSelect = ({ value, onChange }: Props) => {
  const selectedKey = value ?? DEFAULT_DATE_FORMAT_KEY;
  const selectedOption =
    DATE_FORMAT_OPTIONS.find((option) => option.key === selectedKey) ??
    DATE_FORMAT_OPTIONS[0];

  return (
    <div className="flex-1">
      <Label className="text-sm font-normal">Date Format</Label>
      <Select
        options={DATE_FORMAT_OPTIONS}
        value={selectedKey}
        valueGetter={(option) => option.key}
        textGetter={(option) => option.label}
        onChange={(e) => onChange(e.target.value as DateFormatKey)}
      />
      <p className="text-xs text-gray-500 mt-1">
        Example: {format(new Date(), selectedOption.dateFnsFormat)}
      </p>
    </div>
  );
};

export default DateFormatSelect;
